import styled from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '8rem',
  maxHeight: '72rem',
});

export const LogoImage = styled.img({
  display: 'block',
  height: 'auto',
  width: 'auto',
  maxHeight: '64rem',
  maxWidth: '220rem',
  objectFit: 'contain',
});
